import { forEach } from 'lodash';

// Getting media queries from stylesheet files
export default function getAllMediaQueries() {

	let data = window.definedStyleData,
		dataOther,
		mediaSelectors,
		mediaContent,
		mediaList = []

	// Adding Editor data.

	if ( window.Stylist.iDocJQ.find("#stlst-css-data-full").length == 0 ) {
		dataOther = window.stlst_legacy.get_clean_css();
	} else {
		dataOther = window.Stylist.iDocJQ.find("#stlst-css-data-full").html();
	}

	// Getting minimized data.
	data += window.stlst_legacy.get_minimized_css( dataOther, false );


	// if no data, stop.
	if ( data == '' ) {
		return false;
	}

	data = data.toString().replace(/\}\,/g, "}");

	// Getting All media Queries.
	let allMedia = data.match(/@media(.*?){(.*?)}}/g);



	// stop if no media
	if ( window.stlst_legacy.isUndefined( allMedia ) ) {
		return false;
	}

	// Clean array
	allMedia = window.stlst_legacy.array_cleaner( allMedia );

	// Getting just media condition
	let condition = data.match(/@media(.*?){/g);

	// stop if no media
	if ( window.stlst_legacy.isUndefined( condition ) ) {
		return false;
	}

	// Clean array
	condition = window.stlst_legacy.array_cleaner(condition);

	return condition;

}


window.stlst_legacy.getAllMediaQueries = function( css, justCondition ) {
	return getAllMediaQueries( css, justCondition );
}


// Getting media queries from stylesheet files
function getMediaQueryByCss ( css, justCondition ) {

	let data = window.definedStyleData,
		dataOther,
		mediaSelectors,
		mediaContent,
		mediaList = []

	// Adding Editor data for justCondition mode.
	if ( justCondition ) {

		if ( window.Stylist.iDocJQ.find("#stlst-css-data-full").length == 0 ) {
			dataOther = window.stlst_legacy.get_clean_css();
		} else {
			dataOther = window.Stylist.iDocJQ.find("#stlst-css-data-full").html();
		}

		// Getting minimized data.
		data += window.stlst_legacy.get_minimized_css( dataOther, false );

	}

	// if no data, stop.
	if ( data == '' ) {
		return false;
	}

	data = data.toString().replace(/\}\,/g, "}");

	// Getting All media Queries.
	let allMedia = data.match(/@media(.*?){(.*?)}}/g);



	// stop if no media
	if ( window.stlst_legacy.isUndefined( allMedia ) ) {
		return false;
	}

	// Clean array
	allMedia = window.stlst_legacy.array_cleaner( allMedia );

	// Getting just media condition
	let condition = data.match(/@media(.*?){/g);

	// stop if no media
	if ( window.stlst_legacy.isUndefined( condition ) ) {
		return false;
	}

	// Clean array
	condition = window.stlst_legacy.array_cleaner( condition )

	// Stop and return just condition.
	if ( justCondition ) {
		return condition;
	}

	// Each media queries
	$.each(allMedia,function(index,value){

		// Current media CSS
		mediaContent = value.match(/\{(.*?)\}}/g).join("").replace(/\}\}$/g,'}');

		// Getting all selectors inside media
		mediaSelectors = window.stlst_legacy.array_cleaner(mediaContent.replace(/\{(.*?)\}/g, '|BREAK|').split("|BREAK|"));

		// Each all selectors
		$.each( mediaSelectors,function( index, selector ) {

			// End after 50
			if (index > 50){
				return false;
			}

			// Check if there any selector matches the target element
			if ( selector != '' && selector.indexOf("*") == -1  && selector.indexOf(":") == -1 && selector.indexOf("@") == -1 && check_selector(selector,false,false) !== false) {

				if ( window.Stylist.iDocJQ.find(get_foundable_query(selector,true,true,true)).hasClass("stlst-selected")) {

					let ruleAll = mediaContent.match(new RegExp(prepare_regex_string(selector) + "(\s+)?\{(.*?)\}",'gi')).toString();

					let rules = window.stlst_legacy.array_cleaner(ruleAll.match(/\{(.*?)\}/g).toString().replace(/:(.*?)(;|})(\s+)?/g,'|BREAK|').replace(/(\{|\}|\,)/g,'').split("|BREAK|"));

					// If the current media has any selector
					// for target element, so process the media query.
					if ( rules.indexOf(css.replace(/(min-|max-)/g,'')) != -1 ) {

						mediaList.push( value.match(/\@media(.*?){/g).toString().replace("{",'') );

					}
				}
			}
		});
	});


	// Each all media list
	let mediaQueries = [];
	let foundedMedia = false;
	let processed,queryX;
	$.each( window.stlst_legacy.array_cleaner(mediaList),function(index,query){

		// Processed
		processed = window.stlst_legacy.process_media_query(query);

		// Adds mediaQueries
		mediaQueries.push( processed );

		// Basic for check with matchMedia
		queryX = window.stlst_legacy.space_cleaner(query.replace("@media",""));

		// add if it is active
		if (window.matchMedia(queryX).matches && processed != false && processed != null){
			foundedMedia = query;
		}

	});

	if (foundedMedia != false){
		return foundedMedia;
	}

	return window.stlst_legacy.creating_auto_media_query(mediaQueries);

}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/get-all-media-queries.js